import React from 'react';
import { Trophy } from 'lucide-react';

// Versão compacta de VencedorDestaque.js — o original é um hero de página
// inteira com copy específico do Telão Brasil ("local oficial do telão"),
// o que não funciona repetido em cada uma de até 30 perguntas de uma
// enquete dinâmica. Aqui é uma faixa de destaque enxuta, uma por pergunta.
const VencedorDestaqueGenerico = ({ vencedor, totalRespondentes }) => {
  if (!vencedor || vencedor.votos === 0) return null;

  const porcentagem = totalRespondentes > 0
    ? ((vencedor.votos / totalRespondentes) * 100).toFixed(1)
    : 0;

  return (
    <div className="flex items-center gap-3 bg-gradient-to-r from-yellow-50 to-amber-50 border border-yellow-300 rounded-lg px-4 py-2 mb-3">
      <Trophy className="w-5 h-5 text-yellow-600 flex-shrink-0" />
      <p className="text-sm text-gray-800">
        <span className="font-bold">{vencedor.label}</span> é a mais escolhida —{' '}
        <span className="font-semibold">{porcentagem}%</span> das respostas ({vencedor.votos.toLocaleString('pt-BR')})
      </p>
    </div>
  );
};

export default VencedorDestaqueGenerico;
